import { environment } from '@internal/environment/environment'
import { ImageLoader as NextImageLoader } from 'next/image'

// this will automatically prefix images with NEXT_PUBLIC_WEBSITE_ASSETS_CDN_URL
// we want to load images wie imagekit, so we replace WEBSITE_ASSETS_CDN_URL with WEBSITE_ASSETS_CDN_URL_IMAGEKIT
// https://nextjs.org/docs/api-reference/next/image#loader
// https://nextjs.org/docs/api-reference/next/image#built-in-loaders
export const ImageLoader: NextImageLoader = ({ src, width }) => {
  const path = src.replace(environment.WEBSITE_ASSETS_CDN_URL ?? '', '')
  return `${environment.WEBSITE_ASSETS_CDN_URL_IMAGEKIT}${path}?tr=w-${width}`
}
